<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__name>
        <div class="table-default__left">Domain</div>
      </template>
      <template #h__registrar>
        <div class="table-default__left">Registrar</div>
      </template>
      <template #name="{ row }">
        <div class="table-default__left">{{ row.name }}</div>
      </template>
      <template #registrar="{ row }">
        <div class="table-default__left">{{ row.registrar || '-' }}</div>
      </template>
      <template #creation_date="{ row }">
        {{ dateFormat(row.creation_date) }}
      </template>
      <template #expiration_date="{ row }">
        {{ dateFormat(row.expiration_date) }}
      </template>
      <template #days_left="{ row }">
        {{ row.expiration_date ? row.days_left : '-' }}
      </template>
      <template #notification_contacts="{ row }">
        {{ row.notification_contacts.length }}
      </template>
      <template #updated_at="{ row }">
        {{ dateTimeFormat(row.updated_at) }}
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="$emit('updateDomain', row.id)" type="button"><img src="@/assets/img/update-table-icon.svg" alt=""></button>
          <button @click="$emit('editButtonClick', row)" type="button"><img src="@/assets/img/edit-table-icon.svg" alt=""></button>
          <button @click="$emit('tableDomainDelete', row)" type="button"><img src="@/assets/img/delete-table-icon.svg" alt=""></button>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'TableDomains',
  props: ['tableItems', 'tablePreloader', 'pagination'],
  data() {
    return {
      table: {
        columns: ['name', 'registrar', 'creation_date', 'expiration_date', 'days_left', 'notification_contacts', 'updated_at', 'controls'],
        options: {
          headings: {
            'name': 'Domain',
            'registrar': 'Registrar',
            'creation_date': 'Creation date',
            'expiration_date': 'Expiration date',
            'days_left': 'Days left',
            'notification_contacts': 'Notification contacts',
            'updated_at': 'Last update',
            'controls': ''
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  methods: {
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
